<template>
  <div class="">
    <longterm-stock v-if="tab === 'long-term-stock'"></longterm-stock>
    <settings v-if="tab === 'settings'"></settings>
  </div>
</template>
<script>
import LongtermStock from './LongtermStock'
import Settings from './Settings'

export default {
  components: {
    LongtermStock,
    Settings
  },
  props: {
    tab: {
      type: String,
      default: 'long-term-stock'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/salemonAgent/TabContent.vue